
<template>
    <div class="container">
        <div class="bottom_pic">
            <div class="qualification">
                <div class="qualification_top" @click="seeImg()">
                    <img alt="营业执照" src="https://m.yamyamyam.com/mobile/img/businesslicense.jpg" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      imgList1: [],
    };
  },
  methods: {
    seeImg() {
      ImagePreview(['https://m.yamyamyam.com/mobile/img/businesslicense.jpg']);
    }
  }
};
</script>
<style lang="scss" scoped>
.bottom_pic{
    padding: 0 12px;
    .qualification{
          display: flex;
        .qualification_top{
            width: 100%;
            height: 200px;
        }
        img{
           width: 100%;
           height: 100%;
        }
    }
}


</style>

<style scoped>

</style>